"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.spanLinkCss = exports.StyledVideoWrapper = exports.StyledSpanLink = exports.StyledLinksWrapper = exports.StyledLegalText = exports.StyledImageWrapper = exports.StyledHeading = exports.StyledContentCard = exports.StyledBody = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _links = require("../../fuse-link/src/links");
var _grid = require("../../fuse-responsive-grid/src/grid");
var _typography = require("../../fuse-typography-element/src/typography");
function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    "default": e
  };
}
var imageRatios = {
  '1:1': '100%',
  '16:9': '56.25%',
  '4:3': '75%',
  '5:4': '80%',
  '3:4': '133.33%'
};
var spanLinkCss = exports.spanLinkCss = function spanLinkCss(colour) {
  return "\n\tspan {\n\t\tcolor: var(".concat(colour, ");\n\t\ttext-decoration-color: var(").concat(colour, ");\n\t}\n");
};
var StyledBody = exports.StyledBody = (0, _styledComponents["default"])(_typography.TypographyComponent).attrs({
  className: 'fuse-content-card__body',
  'data-testid': 'fuse-content-card-body-test-id'
}).withConfig({
  displayName: "styled-content-card__StyledBody",
  componentId: "sc-rcs1zi-0"
})(["margin-bottom:var(--spacing-global-space6);"]);
var StyledContentCard = exports.StyledContentCard = _styledComponents["default"].a.withConfig({
  displayName: "styled-content-card__StyledContentCard",
  componentId: "sc-rcs1zi-1"
})(["text-decoration:none;margin-bottom:", ";&:hover{", "}&:focus{outline:var(--spacing-global-space1) solid var(--color-functional-focus);outline-offset:var(--spacing-global-space2);", "}&:active{", "}> *:last-child{margin-bottom:0;}"], function (_ref) {
  var removeMargin = _ref.removeMargin;
  return removeMargin ? '0' : 'var(--spacing-global-space6)';
}, spanLinkCss('--color-brand-dark'), spanLinkCss('--color-brand-dark'), spanLinkCss('--color-global-black'));
var StyledHeading = exports.StyledHeading = (0, _styledComponents["default"])(_typography.TypographyComponent).attrs({
  className: 'fuse-content-card__heading',
  'data-testid': 'fuse-content-card-heading-test-id'
}).withConfig({
  displayName: "styled-content-card__StyledHeading",
  componentId: "sc-rcs1zi-2"
})(["margin-bottom:", ";"], function (props) {
  return props.body ? 'var(--spacing-global-space2)' : 'var(--spacing-global-space6)';
});
var StyledImageWrapper = exports.StyledImageWrapper = _styledComponents["default"].div.attrs({
  className: 'fuse-content-card__image-wrapper',
  'data-testid': 'fuse-content-card-image-wrapper'
}).withConfig({
  displayName: "styled-content-card__StyledImageWrapper",
  componentId: "sc-rcs1zi-3"
})(["margin-bottom:var(--spacing-global-space5);@media screen and (min-width:", "){margin-bottom:var(--spacing-global-space6);}padding-bottom:", ";position:relative;img{position:absolute;top:0;left:0;height:100%;width:100%;object-fit:cover;}"], _grid.gridConfig.s.minWidth, function (_ref2) {
  var aspectRatio = _ref2.aspectRatio;
  return aspectRatio ? imageRatios[aspectRatio] : imageRatios['1:1'];
});
var StyledVideoWrapper = exports.StyledVideoWrapper = _styledComponents["default"].div.attrs({
  className: 'fuse-content-card__video-wrapper',
  'data-testid': 'fuse-content-card-video-wrapper'
}).withConfig({
  displayName: "styled-content-card__StyledVideoWrapper",
  componentId: "sc-rcs1zi-4"
})(["margin-bottom:var(--spacing-global-space5);@media screen and (min-width:", "){margin-bottom:var(--spacing-global-space6);}"], _grid.gridConfig.s.minWidth);
var StyledSpanLink = exports.StyledSpanLink = (0, _styledComponents["default"])(_links.SpanLink).attrs({
  className: 'fuse-content-card__span-link',
  'data-testid': 'fuse-content-card-span-link-test-id'
}).withConfig({
  displayName: "styled-content-card__StyledSpanLink",
  componentId: "sc-rcs1zi-5"
})(["margin-bottom:var(--spacing-global-space6);"]);
var StyledLinksWrapper = exports.StyledLinksWrapper = _styledComponents["default"].div.attrs({
  className: 'fuse-content-card__links-wrapper',
  'data-testid': 'fuse-content-card-links-wrapper-test-id'
}).withConfig({
  displayName: "styled-content-card__StyledLinksWrapper",
  componentId: "sc-rcs1zi-6"
})(["display:inline-flex;flex-direction:column;gap:var(--spacing-global-space5);margin-bottom:var(--spacing-global-space6);"]);
var StyledLegalText = exports.StyledLegalText = (0, _styledComponents["default"])(_typography.TypographyComponent).attrs({
  className: 'fuse-content-card__legal-text',
  'data-testid': 'fuse-content-card-legal-text-test-id'
}).withConfig({
  displayName: "styled-content-card__StyledLegalText",
  componentId: "sc-rcs1zi-7"
})(["color:var(--color-global-grey900);"]);